import { ProductCode } from '@gb-ticket/shared-types';
import {
  CalendarDaysIcon,
  CarFrontIcon,
  HammerIcon,
  HeadsetIcon,
  NewspaperIcon,
  UserRoundPlusIcon,
  WrenchIcon,
  type LucideIcon,
} from 'lucide-react';

import { cn } from '@/lib/utils';

/** One Lucide mark per product. Used by the sidebar switcher, menu sheet, and hub tiles. */
export const PRODUCT_ICONS: Record<ProductCode, LucideIcon> = {
  [ProductCode.INTRANET]: NewspaperIcon,
  [ProductCode.HELPDESK]: HeadsetIcon,
  [ProductCode.LEAVE]: CalendarDaysIcon,
  [ProductCode.FLEET]: CarFrontIcon,
  [ProductCode.MAINTENANCE]: WrenchIcon,
  [ProductCode.ONBOARDING]: UserRoundPlusIcon,
  [ProductCode.TOOLS]: HammerIcon,
};

export function productIcon(code: ProductCode): LucideIcon {
  return PRODUCT_ICONS[code];
}

export function ProductPictogram({ code, className }: { code: ProductCode; className?: string }) {
  const Icon = PRODUCT_ICONS[code];
  return <Icon aria-hidden className={cn('size-4', className)} strokeWidth={1.75} />;
}

/** Rounded well so the mark reads as a module pictogram at a glance. */
export function ProductPictogramMark({
  code,
  className,
  size = 'md',
}: {
  code: ProductCode;
  className?: string;
  size?: 'sm' | 'md';
}) {
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-md bg-primary/10 text-primary',
        size === 'sm' ? 'size-7' : 'size-8',
        className,
      )}
    >
      <ProductPictogram code={code} className={size === 'sm' ? 'size-3.5' : 'size-4'} />
    </span>
  );
}
